// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td[data-v-bd50128a],\nth[data-v-bd50128a] {\n  border-bottom: 1px solid #eff2f7;\n  border-top: 0;\n}", ""]);
// Exports
module.exports = exports;
